import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createExam } from '../services/examService';
import TopicDetailModal from '../components/TopicDetailModal';

const AddExam = () => {
  const navigate = useNavigate();
  const [examType, setExamType] = useState('TYT');
  const [examDate, setExamDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Topic detail modal state
  const [topicModalOpen, setTopicModalOpen] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState('');
  const [topicDetailsData, setTopicDetailsData] = useState({});

  // TYT sonuçları
  const [tytResults, setTytResults] = useState({
    turkish: { correct: 0, wrong: 0, blank: 0 },
    math: { correct: 0, wrong: 0, blank: 0 },
    science: { correct: 0, wrong: 0, blank: 0 },
    physics: { correct: 0, wrong: 0, blank: 0 },
    chemistry: { correct: 0, wrong: 0, blank: 0 },
    biology: { correct: 0, wrong: 0, blank: 0 },
    social: { correct: 0, wrong: 0, blank: 0 },
    history: { correct: 0, wrong: 0, blank: 0 },
    geography: { correct: 0, wrong: 0, blank: 0 },
    philosophy: { correct: 0, wrong: 0, blank: 0 },
    religion: { correct: 0, wrong: 0, blank: 0 }
  });

  // AYT sonuçları
  const [aytResults, setAytResults] = useState({
    mathAyt: { correct: 0, wrong: 0, blank: 0 },
    physics: { correct: 0, wrong: 0, blank: 0 },
    chemistry: { correct: 0, wrong: 0, blank: 0 },
    biology: { correct: 0, wrong: 0, blank: 0 },
    literature: { correct: 0, wrong: 0, blank: 0 },
    history1: { correct: 0, wrong: 0, blank: 0 },
    geography1: { correct: 0, wrong: 0, blank: 0 },
    history2: { correct: 0, wrong: 0, blank: 0 },
    geography2: { correct: 0, wrong: 0, blank: 0 },
    philosophy: { correct: 0, wrong: 0, blank: 0 },
    religion: { correct: 0, wrong: 0, blank: 0 },
    language: { correct: 0, wrong: 0, blank: 0 }
  });

  const tytSubjects = [
    { key: 'turkish', label: 'Türkçe', total: 40, icon: '📖', hasTopics: true, topicSubject: 'TYT-Türkçe' },
    { key: 'math', label: 'Matematik', total: 40, icon: '🔢', hasTopics: true, topicSubject: 'TYT-Matematik' },
    {
      key: 'science',
      label: 'Fen Bilimleri',
      total: 20,
      icon: '🔬',
      hasTopics: false,
      subSubjects: [
        { key: 'physics', label: 'Fizik', total: 7, icon: '⚛️', hasTopics: true, topicSubject: 'TYT-Fizik' },
        { key: 'chemistry', label: 'Kimya', total: 7, icon: '🧪', hasTopics: true, topicSubject: 'TYT-Kimya' },
        { key: 'biology', label: 'Biyoloji', total: 6, icon: '🧬', hasTopics: true, topicSubject: 'TYT-Biyoloji' }
      ]
    },
    {
      key: 'social',
      label: 'Sosyal Bilimler',
      total: 20,
      icon: '🌍',
      hasTopics: false,
      subSubjects: [
        { key: 'history', label: 'Tarih', total: 5, icon: '🏛️', hasTopics: true, topicSubject: 'TYT-Tarih' },
        { key: 'geography', label: 'Coğrafya', total: 5, icon: '🗺️', hasTopics: true, topicSubject: 'TYT-Coğrafya' },
        { key: 'philosophy', label: 'Felsefe', total: 5, icon: '💭', hasTopics: true, topicSubject: 'TYT-Felsefe' },
        { key: 'religion', label: 'Din Kültürü', total: 5, icon: '☪️', hasTopics: true, topicSubject: 'TYT-Din' }
      ]
    }
  ];

  // AYT subjects - bunlar değişmedi, AYT konuları topics tablosunda 'Matematik', 'Fizik' vs. olarak kayıtlı
  const aytSubjects = {
    sayisal: [
      { key: 'mathAyt', label: 'Matematik', total: 40, icon: '🔢', hasTopics: true, topicSubject: 'Matematik' },
      { key: 'physics', label: 'Fizik', total: 14, icon: '⚛️', hasTopics: true, topicSubject: 'Fizik' },
      { key: 'chemistry', label: 'Kimya', total: 13, icon: '🧪', hasTopics: true, topicSubject: 'Kimya' },
      { key: 'biology', label: 'Biyoloji', total: 13, icon: '🧬', hasTopics: true, topicSubject: 'Biyoloji' }
    ],
    sozel: [
      { key: 'literature', label: 'Edebiyat', total: 24, icon: '📚' },
      { key: 'history1', label: 'Tarih-1', total: 10, icon: '🏛️' },
      { key: 'geography1', label: 'Coğrafya-1', total: 6, icon: '🗺️' },
      { key: 'history2', label: 'Tarih-2', total: 11, icon: '📜' },
      { key: 'geography2', label: 'Coğrafya-2', total: 11, icon: '🌏' },
      { key: 'philosophy', label: 'Felsefe', total: 12, icon: '💭' },
      { key: 'religion', label: 'Din Kültürü', total: 6, icon: '☪️' }
    ],
    dil: [
      { key: 'language', label: 'Yabancı Dil', total: 80, icon: '🗣️' }
    ]
  };

  const handleTytChange = (subject, field, value) => {
    const numValue = parseInt(value) || 0;
    setTytResults(prev => ({
      ...prev,
      [subject]: {
        ...prev[subject],
        [field]: numValue
      }
    }));
  };

  const handleAytChange = (subject, field, value) => {
    const numValue = parseInt(value) || 0;
    setAytResults(prev => ({
      ...prev,
      [subject]: {
        ...prev[subject],
        [field]: numValue
      }
    }));
  };

  const calculateNet = (correct, wrong) => {
    return Math.max(0, correct - (wrong / 4)).toFixed(2);
  };

  const getTotalNet = (results) => {
    return Object.values(results).reduce((total, subject) => {
      return total + parseFloat(calculateNet(subject.correct, subject.wrong));
    }, 0).toFixed(2);
  };

  const openTopicModal = (subjectKey, subjectLabel) => {
    setSelectedSubject(subjectKey);
    setSelectedSubjectLabel(subjectLabel);
    setTopicModalOpen(true);
  };

  const handleTopicDetailSave = (subject, topicResults) => {
    setTopicDetailsData(prev => ({
      ...prev,
      [subject]: topicResults
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const results = examType === 'TYT' ? tytResults : aytResults;
      
      await createExam({
        examType,
        examDate,
        results
      });

      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Deneme eklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-6">
          <Link
            to="/dashboard"
            className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-4"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Dashboard'a Dön
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Yeni Deneme Ekle</h1>
          <p className="mt-2 text-gray-600">Deneme sonuçlarınızı girerek performansınızı takip edin</p>
        </div>

        {error && (
          <div className="mb-6 bg-error-50 border border-error-200 rounded-lg p-4">
            <p className="text-error-700">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Exam Type and Date */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Sınav Türü
                </label>
                <select
                  value={examType}
                  onChange={(e) => setExamType(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                >
                  <option value="TYT">TYT</option>
                  <option value="AYT">AYT</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Sınav Tarihi
                </label>
                <input
                  type="date"
                  value={examDate}
                  onChange={(e) => setExamDate(e.target.value)}
                  max={new Date().toISOString().split('T')[0]}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
          </div>

          {/* TYT Results */}
          {examType === 'TYT' && (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-6">TYT Sonuçları</h2>
              
              <div className="space-y-6">
                {tytSubjects.map((subject) => (
                  <div key={subject.key}>
                    {/* Main Subject */}
                    {!subject.subSubjects ? (
                      <div className="border-b border-gray-200 pb-6">
                        <div className="flex items-center justify-between mb-4">
                          <div className="flex items-center gap-3">
                            <h3 className="text-lg font-semibold text-gray-900">
                              {subject.icon} {subject.label}
                              <span className="text-sm text-gray-500 ml-2">({subject.total} Soru)</span>
                            </h3>
                            {subject.hasTopics && (
                              <button
                                type="button"
                                onClick={() => openTopicModal(subject.topicSubject, subject.label)}
                                className="px-3 py-1 text-sm bg-primary-100 text-primary-700 rounded-lg hover:bg-primary-200 transition flex items-center gap-1"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                                Konu Detayları
                                {topicDetailsData[subject.topicSubject] && (
                                  <span className="bg-green-500 text-white text-xs px-1.5 py-0.5 rounded-full">✓</span>
                                )}
                              </button>
                            )}
                          </div>
                          <div className="text-right">
                            <p className="text-sm text-gray-500">Net</p>
                            <p className="text-2xl font-bold text-primary-600">
                              {calculateNet(
                                tytResults[subject.key].correct,
                                tytResults[subject.key].wrong
                              )}
                            </p>
                          </div>
                        </div>

                        <div className="grid grid-cols-3 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Doğru
                            </label>
                            <input
                              type="number"
                              min="0"
                              max={subject.total}
                              value={tytResults[subject.key].correct}
                              onChange={(e) => handleTytChange(subject.key, 'correct', e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Yanlış
                            </label>
                            <input
                              type="number"
                              min="0"
                              max={subject.total}
                              value={tytResults[subject.key].wrong}
                              onChange={(e) => handleTytChange(subject.key, 'wrong', e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Boş
                            </label>
                            <input
                              type="number"
                              min="0"
                              max={subject.total}
                              value={tytResults[subject.key].blank}
                              onChange={(e) => handleTytChange(subject.key, 'blank', e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-transparent"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      /* Subject with sub-subjects (Fen Bilimleri) */
                      <div className="border-b border-gray-200 pb-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">
                          {subject.icon} {subject.label}
                          <span className="text-sm text-gray-500 ml-2">({subject.total} Soru)</span>
                        </h3>
                        <div className="space-y-4 ml-4">
                          {subject.subSubjects.map((subSubject) => (
                            <div key={subSubject.key} className="border-l-4 border-primary-200 pl-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-center gap-2">
                                  <h4 className="text-base font-medium text-gray-800">
                                    {subSubject.icon} {subSubject.label}
                                    <span className="text-xs text-gray-500 ml-2">({subSubject.total} Soru)</span>
                                  </h4>
                                  {subSubject.hasTopics && (
                                    <button
                                      type="button"
                                      onClick={() => openTopicModal(subSubject.topicSubject, subSubject.label)}
                                      className="px-2 py-0.5 text-xs bg-primary-100 text-primary-700 rounded hover:bg-primary-200 transition flex items-center gap-1"
                                    >
                                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                      </svg>
                                      Konular
                                      {topicDetailsData[subSubject.topicSubject] && (
                                        <span className="bg-green-500 text-white text-xs px-1 py-0.5 rounded-full">✓</span>
                                      )}
                                    </button>
                                  )}
                                </div>
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Net</p>
                                  <p className="text-lg font-bold text-primary-600">
                                    {calculateNet(
                                      tytResults[subSubject.key].correct,
                                      tytResults[subSubject.key].wrong
                                    )}
                                  </p>
                                </div>
                              </div>

                              <div className="grid grid-cols-3 gap-3">
                                <div>
                                  <label className="block text-xs font-medium text-gray-600 mb-1">
                                    Doğru
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    max={subSubject.total}
                                    value={tytResults[subSubject.key].correct}
                                    onChange={(e) => handleTytChange(subSubject.key, 'correct', e.target.value)}
                                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                  />
                                </div>

                                <div>
                                  <label className="block text-xs font-medium text-gray-600 mb-1">
                                    Yanlış
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    max={subSubject.total}
                                    value={tytResults[subSubject.key].wrong}
                                    onChange={(e) => handleTytChange(subSubject.key, 'wrong', e.target.value)}
                                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                                  />
                                </div>

                                <div>
                                  <label className="block text-xs font-medium text-gray-600 mb-1">
                                    Boş
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    max={subSubject.total}
                                    value={tytResults[subSubject.key].blank}
                                    onChange={(e) => handleTytChange(subSubject.key, 'blank', e.target.value)}
                                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-transparent"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Total Net */}
              <div className="mt-6 pt-6 border-t-2 border-gray-300">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-gray-900">Toplam Net</h3>
                  <p className="text-3xl font-bold text-primary-600">
                    {getTotalNet(tytResults)}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* AYT Results */}
          {examType === 'AYT' && (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-6">AYT Sonuçları</h2>
              
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Alan Seçin
                </label>
                <div className="flex gap-2">
                  <button
                    type="button"
                    className="px-4 py-2 rounded-lg font-medium bg-primary-600 text-white"
                  >
                    Sayısal
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 rounded-lg font-medium bg-gray-200 text-gray-700"
                  >
                    Sözel
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 rounded-lg font-medium bg-gray-200 text-gray-700"
                  >
                    Dil
                  </button>
                </div>
              </div>

              <div className="space-y-6">
                {aytSubjects.sayisal.map((subject) => (
                  <div key={subject.key} className="border-b border-gray-200 pb-6 last:border-0">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <h3 className="text-lg font-semibold text-gray-900">
                          {subject.icon} {subject.label}
                          <span className="text-sm text-gray-500 ml-2">({subject.total} Soru)</span>
                        </h3>
                        {subject.hasTopics && (
                          <button
                            type="button"
                            onClick={() => openTopicModal(subject.topicSubject, subject.label)}
                            className="px-3 py-1 text-sm bg-primary-100 text-primary-700 rounded-lg hover:bg-primary-200 transition flex items-center gap-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            Konu Detayları
                            {topicDetailsData[subject.topicSubject] && (
                              <span className="bg-green-500 text-white text-xs px-1.5 py-0.5 rounded-full">✓</span>
                            )}
                          </button>
                        )}
                      </div>
                      <div className="text-right">
                        <p className="text-sm text-gray-500">Net</p>
                        <p className="text-2xl font-bold text-primary-600">
                          {calculateNet(
                            aytResults[subject.key].correct,
                            aytResults[subject.key].wrong
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Doğru
                        </label>
                        <input
                          type="number"
                          min="0"
                          max={subject.total}
                          value={aytResults[subject.key].correct}
                          onChange={(e) => handleAytChange(subject.key, 'correct', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Yanlış
                        </label>
                        <input
                          type="number"
                          min="0"
                          max={subject.total}
                          value={aytResults[subject.key].wrong}
                          onChange={(e) => handleAytChange(subject.key, 'wrong', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Boş
                        </label>
                        <input
                          type="number"
                          min="0"
                          max={subject.total}
                          value={aytResults[subject.key].blank}
                          onChange={(e) => handleAytChange(subject.key, 'blank', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Total Net */}
              <div className="mt-6 pt-6 border-t-2 border-gray-300">
                <div className="flex items-center justify-between">
                  <h3 className="text-xl font-bold text-gray-900">Toplam Net</h3>
                  <p className="text-3xl font-bold text-primary-600">
                    {getTotalNet(aytResults)}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="flex-1 px-6 py-3 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Kaydediliyor...
                </span>
              ) : (
                'Denemeyi Kaydet'
              )}
            </button>
          </div>
        </form>

        {/* Topic Detail Modal */}
        <TopicDetailModal
          isOpen={topicModalOpen}
          onClose={() => setTopicModalOpen(false)}
          examId={null}
          subject={selectedSubject}
          subjectLabel={selectedSubjectLabel}
          onSave={handleTopicDetailSave}
        />
      </div>
    </div>
  );
};

export default AddExam;
